import { DefaultHardStop } from "components/AppendixScreen/DefaultHardStop";
import {
  CONTACT_US_HEADER,
  DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_1,
  DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_2,
  BOUNCE_BACK_FAQ_LINKS,
} from "./HardStops.const";
import { brand } from "services/envService";
import { HOW_TO_CONTACT_US_TITLE } from "screens/Title.const";

const BRAND = brand();

export const NoPaygHardstop = () => {
  document.title = HOW_TO_CONTACT_US_TITLE;
  return (
    <DefaultHardStop header={CONTACT_US_HEADER}>
      <>
        <span>
          {DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_1}{" "}
          <a
            rel="noreferrer"
            target="_blank"
            href={BOUNCE_BACK_FAQ_LINKS[BRAND]}
          >
            here
          </a>{" "}
          {DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_2}
        </span>
      </>
    </DefaultHardStop>
  );
};
